import Route from '@ember/routing/route';

export default class TransfermarktRoute extends Route {}
